// @flow

import Config from "../constants/Config";

const LoadPayPalSDK = () => {
    return new Promise((resolve, reject) => {
        if (window.paypal) {
            resolve();
        } else {
            // timeout reject
            const requestTimeout = setTimeout(() => {
                clearInterval(loadCheckInterval);
                reject("LoadPayPalSDK timed out.");
            }, Config.fetchTimeout);

            // loaded check resolve
            const loadCheckInterval = setInterval(() => {
                if (window.paypal) {
                    clearTimeout(requestTimeout);
                    clearInterval(loadCheckInterval);
                    resolve();
                }
            }, 50);

            // async script include
            const paypalJs = document.createElement("script");
            paypalJs.type = "text/javascript";
            paypalJs.src = `https://www.paypal.com/sdk/js?client-id=${Config.paypalClientId}&merchant-id=${Config.paypalMerchantId}&currency=AUD`;
            if (document && document.body) document.body.appendChild(paypalJs);
        }
    });
};

export default LoadPayPalSDK;
